var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9948 14.168H30.6615C30.2006 14.168 29.8281 13.7955 29.8281 13.3346V10.0013C29.8281 9.54047 30.2006 9.16797 30.6615 9.16797H38.9948C39.4556 9.16797 39.8281 9.54047 39.8281 10.0013V13.3346C39.8281 13.7955 39.4556 14.168 38.9948 14.168Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 14.168V31.668C31.5 32.1288 31.1275 32.5013 30.6667 32.5013H25.5",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8019 32.5007L23.9469 22.0615C23.7494 21.3373 23.0911 20.834 22.3394 20.834H12.4202C11.5894 20.834 10.8202 21.4015 10.6869 22.2207C10.5169 23.2648 11.3186 24.1673 12.3311 24.1673H19.8311",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 44.1673C43.5126 44.1673 46.4974 41.1825 46.4974 37.5006C46.4974 33.8188 43.5126 30.834 39.8307 30.834C36.1488 30.834 33.1641 33.8188 33.1641 37.5006C33.1641 41.1825 36.1488 44.1673 39.8307 44.1673Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8281 40.002C41.2088 40.002 42.3281 38.8827 42.3281 37.502C42.3281 36.1212 41.2088 35.002 39.8281 35.002C38.4474 35.002 37.3281 36.1212 37.3281 37.502C37.3281 38.8827 38.4474 40.002 39.8281 40.002Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4974 37.502C21.4974 41.1836 18.5124 44.1686 14.8307 44.1686C11.1491 44.1686 8.16406 41.1836 8.16406 37.502",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8307 13.3353H26.4974C26.0366 13.3353 25.6641 12.9628 25.6641 12.502V10.8353C25.6641 10.3745 26.0366 10.002 26.4974 10.002H29.8307",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1953 14.168C36.8461 19.793 45.6611 22.5013 45.6611 28.3346V34.2713",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1641 37.5022H6.4974C6.03656 37.5022 5.66406 37.1297 5.66406 36.6689V30.8355C5.66406 27.408 7.95573 24.5172 11.0974 23.623",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 36.6673C5.66406 32.0657 9.3949 28.334 13.9974 28.334",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33073 18.334H6.66406V20.0007H8.33073V18.334Z",
    fill: "#2D2D2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 20H10.8359V21.6667H12.5026V20Z",
    fill: "#2D2D2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2881 37.3983C23.3181 37.125 23.334 36.8467 23.334 36.565C23.334 34.4267 22.5281 32.4758 21.2031 31",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7895 20.9123H3.87719C3.39211 20.9123 3 20.4362 3 19.8471V7.06516C3 6.47613 3.39211 6 3.87719 6H17.9123C18.3974 6 18.7895 6.47613 18.7895 7.06516V20.9123Z",
    fill: "#0098FF",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.23173b8da630a3816c0b2a3950cb3e0b.svg";
export { ForwardRef as ReactComponent };